<!-- 紧缺库存采购>库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main urgent-purchase">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase" @click="gotoQuickBuy()">{{ permission.stockPurchase }}</el-button>
                <el-button size="small" class="search-btn" v-if="permission.oldUrgentPur" @click="gotoOldVers()">{{ permission.oldUrgentPur }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码、互换码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" v-filter-special-char="searchData.APCode" placeholder="汽配编码、互换码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" v-filter-special-char="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" v-filter-special-char="searchData.AutoSerise" placeholder="适用车型"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.BrandName"
                        filterable
                        clearable
                        size="small"
                        @change="brandChange()"
                        @visible-change="brandVisibleChange($event)"
                        style="width: 100%"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.ExAttribute1"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        size="small"
                        style="width: 100%"
                        :remote-method="searchCate"
                        v-select-scroll-more="searchCateLoad"
                        @visible-change="cateVisibleChange($event)"
                        placeholder="请输入汽配分类"
                    >
                        <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                    :row-key="getRowKeys"
                    :tableCode="tableCode"
                    :default-sort="{ prop: 'Balance', order: 'ascending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column fixed type="selection" reserve-selection width="55"></el-table-column>
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            fixed
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'APCode'"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'NeedIn'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" v-if="scope.row.NeedIn > 0" @click="showNeedInData(scope.row)">{{ scope.row.NeedIn }}</el-link>
                                <el-link v-else disabled>{{ scope.row.NeedIn }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'NeedOut'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" v-if="scope.row.NeedOut > 0" @click="showNeedOutData(scope.row)">{{ scope.row.NeedOut }}</el-link>
                                <el-link v-else disabled>{{ scope.row.NeedOut }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'BadGoodsCount'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">存放在废品仓的商品数量</div>
                                    <span>
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                </el-tooltip>
                                {{ col.ColumnName }} </template
                            ><template slot-scope="scope">
                                <span>{{ scope.row.BadGoodsCount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'Balance'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">
                                        {{ isAddWaitIn ? '留余目前暂未减去废品数（留余 = 库存数 + 待入 - 待出）' : '留余目前暂未减去废品数（留余 = 库存数 - 待出）' }}
                                    </div>
                                    <span>
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                </el-tooltip>
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <i class="out-active">{{ scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ? scope.row.NeedIn : 0) - scope.row.BadGoodsCount }}</i></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'DeliveryDate'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">回货周期是商品自提交采购订单到采购入库的时间，时间单位为天</div>
                                    <span>
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                </el-tooltip>
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.DeliveryDate }}</template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'RelpCount'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">推荐采购量是通过近期的【销售出货量 * 权重】及【回货周期中位数】计算得出</div>
                                    <span>
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                </el-tooltip>
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope"
                                ><i class="cr-active">{{
                                    scope.row.RelpCount - (scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ? scope.row.NeedIn : 0) - scope.row.BadGoodsCount) > 0
                                        ? Math.ceil(scope.row.RelpCount - (scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ? scope.row.NeedIn : 0) - scope.row.BadGoodsCount))
                                        : '-'
                                }}</i></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '100px'"
                            :label="col.ColumnName"
                            resizable
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'Origin'"
                        >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" width="100" :isCanSet="true" v-if="permission.purStates">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img class="image-sup" src="@/assets/images/sup.png" title="采购历史" @click="showHistories(scope.row.GoodsId)" />
                                <img class="image-cus" src="@/assets/images/cus.png" title="销售历史" @click="showSaleStat(scope.row)" />
                                <img src="../../../assets/images/analysis.png" style="width: 23px; height: 23px; margin-left: 6px" title="数据分析" @click="analysis(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="商品销售采购数据图表"
            :visible.sync="goodsAnalysisVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis ref="goodsAnalysis" :GoodsId="goodsId" @closeDialog="goodsAnalysisVisible = false" :NoInit="true"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-dialog :title="NeedIOTitle" :close-on-click-modal="false" :visible.sync="needInDataVisible" append-to-body width="900px">
            <div v-if="needInDataVisible">
                <APNeedInDatas :EntpTempGoodsId="goodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog :title="NeedIOTitle" :close-on-click-modal="false" :visible.sync="needOutDataVisible" append-to-body width="900px">
            <div v-if="needOutDataVisible">
                <APNeedOutDatas :EntpTempGoodsId="goodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory :EntpTempGoodsId="goodsId" @closeDialog="historyVisible = false"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="goodsId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        APMsg,
        breadcrumb,
        goodsAnalysis,
        elTableColumn,
        APNeedInDatas,
        APNeedOutDatas,
        APPurchaseHistory,
        APHistory
    },
    data() {
        return {
            tableCode: 'UrgentPurchaseTable',
            multipleSelection: [],
            brand: [],
            noData: false,
            typeList: [],
            goodsType: '',
            APMsgVisible: false,
            goodsId: '',
            goodsAnalysisVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedIOTitle: '',
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                ExAttribute1: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            columnShowSets: [],
            SaleDialogTitle: '',
            historyVisible: false,
            eyeHistoryVisible: false,
            isAddWaitIn: this
        };
    },
    created() {
        this.getStayCalValue();
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getPermission('inventoryBuy');
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.GoodsId;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转直接采购
        gotoQuickBuy() {
            if (!this.multipleSelection[0]) {
                this.$util.warningMsg('请选择汽配');
                return;
            }
            this.$util.setLocalStorage('QuickBuyAP', this.multipleSelection);
            this.$router.push('/purchaseManage/stockPurchase/easyPurchase_new?type=3');
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                ExAttribute1: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 选中汽配分类
        chooseNode(data) {
            if (data) {
                this.goodsType = data.Item.Name;
                this.searchData.CascadeId = data.Item.CascadeId;
            } else {
                this.goodsType = '';
                this.searchData.CascadeId = '';
            }
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpUrgentPurPartList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.GoodsId) {
                this.goodsId = event.GoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        gotoOldVers() {
            this.$router.push('/purchaseManage/stockPurchase');
        },
        analysis(item) {
            let id = item ? item.GoodsId : '';
            let that = this;
            if (id) {
                that.goodsId = id;
                if (!that.goodsAnalysisVisible) that.goodsAnalysisVisible = true;
                that.$nextTick(function () {
                    that.$refs.goodsAnalysis.updateTableData(id);
                });
            } else {
                that.$util.warningMsg('商品数据异常，请刷新后重新操作');
            }
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.typeList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.typeList = [...this.typeList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchCate('');
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        showNeedInData(item) {
            if (item.GoodsId) {
                this.goodsId = item.GoodsId;
                this.NeedIOTitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            }
        },
        showNeedOutData(item) {
            if (item.GoodsId) {
                this.goodsId = item.GoodsId;
                this.NeedIOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        // 采购历史
        showHistories(id) {
            if (id) {
                this.goodsId = id;
                this.historyVisible = true;
            }
        },
        //销售数据
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.goodsId = row.GoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        //获取留余的计算方式
        getStayCalValue() {
            this.$util.getSysConfig('lybsdr').then(res => {
                this.isAddWaitIn = !res.Result;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;
    p {
        padding-top: 10px;
    }
}
.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}
.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.qp-cover {
    text-align: center;
    overflow: hidden;
    img {
        max-height: 218px;
        max-width: 218px;
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}
@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 3px;
}
</style>
<style lang="less">
.urgent-purchase {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
    .el-table .warning-row {
        background: oldlace;
    }
    .el-table .success-row {
        background: #f0f9eb;
    }
    .el-table .error-row {
        background: rgb(255, 176, 176);
    }
}
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
